import { type } from 'arktype';

export const paginationQuerySchema = type({
  'page?': 'number>=1',
  'limit?': 'number>=1',
  'sortBy?': 'string',
  'sortOrder?': '"asc"|"desc"',
});

export type PaginationQuery = typeof paginationQuerySchema.t;

export const listMetaSchema = type({
  take: 'number>=1',
  skip: 'number>=0',
  count: 'number>=0',
  total: 'number>=0',
  hasMore: 'boolean',
});

export type ListMeta = typeof listMetaSchema.t;

export interface ListResponse<T> {
  data: T[];
  meta: ListMeta;
}

export function createListResponse<T>(data: T[], total: number, take: number, skip: number): ListResponse<T> {
  const count = data.length;
  return {
    data,
    meta: {
      take,
      skip,
      count,
      total,
      hasMore: skip + count < total,
    },
  };
}

/**
 * Build an empty list envelope. Used to short-circuit owned-data list endpoints
 * (e.g. `filter=mine`) when the authenticated caller resolves to no owner —
 * returning an empty page instead of an unscoped result set.
 */
export function createEmptyListResponse<T>(take = 0, skip = 0): ListResponse<T> {
  return createListResponse<T>([], 0, take, skip);
}
